/* eslint-disable react-hooks/exhaustive-deps */
import { Divider } from 'antd';
import { connect } from 'react-redux';
import { CloseOutlined } from '@ant-design/icons';
import { FilterButton } from 'datastake-daf/dist/components';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import ModalFilters from '../progressive-modal-filters';
import IncidentsTrend from '../../widgets/incidents-trend';
import MitigationActionsTrend from '../../widgets/mitigation-actions-trend';
import { filtersConfig, data } from './helper';

import { FilterContainerStyle } from './style';
import EventsDistribution from '../../widgets/events-distribution';
import { actions } from '../../../../../../../store/reducers/dashboard';
import useFetchHelper from '../../../../../../../helpers/useFetchHelper';

const RecordedEventsSection = ({
  incidentsTrend = null,
  mitigationActionsTrend = null,
  eventsDistribution = null,
  selectedProject = null,
  t = (t) => t,
  organisationName = null,
  options = null,
  PmeDashboardGetWithFilters,
  language,
  sourceAndProject,
}) => {
  const ref = useRef();
  const { canFetch } = useFetchHelper({ ref });
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [activeFilters, setActiveFilters] = useState({});
  const [clearFilters, setClearFilters] = useState(false);
  const [filters, setFilters] = useState({});
  const [riskCategorySelected, setRiskCategorySelected] = useState(undefined);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (activeFilters.riskCategory !== riskCategorySelected) {
      setRiskCategorySelected(activeFilters.riskCategory);
    }
  }, [activeFilters]);

  const initialFilters = useMemo(() => filtersConfig.map((filter) => {
    if (filter.type === 'radioGroup') {
      return {
        ...filter,
        items: data[filter.key] || [],
      };
    } else if (filter.type === 'select') {
      if (options) {
        return {
          ...filter,
          items: options[filter.key] || [],
        }
      }
      return { ...filter, items: [] };
    }
    return {};
  }), [selectedProject, options]);

  const isActive = useMemo(() => Object.keys(activeFilters || {}).length > 0, [activeFilters]);

  const update = (filters) => {
    if (canFetch) {
      PmeDashboardGetWithFilters({ widget: 'incidentsTrend', filters });
      PmeDashboardGetWithFilters({ widget: 'mitigationActionsTrend', filters });
      PmeDashboardGetWithFilters({ widget: 'sdgs', filters });
    }
  };

  useEffect(() => {
    if (canFetch) {
      setActiveFilters({});
      setClearFilters(true);
      PmeDashboardGetWithFilters({ widget: 'incidentsTrend', filters: {} });
      PmeDashboardGetWithFilters({ widget: 'mitigationActionsTrend', filters: {} });
      PmeDashboardGetWithFilters({ widget: 'sdgs', filters: {} });
      if (!loaded) {
        setLoaded(true);
      }
    }
  }, [language, canFetch, selectedProject, sourceAndProject]);

  const onSubmit = (val) => {
    if (val) {
      if (val.riskType || val.riskCategory) {
        const filters = {
          riskType: val.riskType,
          riskCategory: val.riskCategory,
        };
        setFilters(filters);
        update(filters);
      } else {
        setFilters({ val });
        update(val);
      }
    } else {
      setFilters(filters);
      update();
    }
  };

  const clearFiltersClicked = (dontDoSubmit = false, changedSource = false) => {
    setActiveFilters({});
    setClearFilters(true);
    if ((activeFilters.riskType || activeFilters.riskCategory) || changedSource) {
      if (!dontDoSubmit) {
        onSubmit(null);
      }
    }
  };

  return (
    <div className="section-col" ref={ref}>
      <Divider orientation="left" style={{ position: 'relative' }}>
        {t('Dashboard::Recorded Events')}
        <FilterContainerStyle>
          {isActive && (
            <div className="clear-filters" onClick={() => clearFiltersClicked(false)}>
              <div>
                <CloseOutlined
                  className="close-icon"
                />
              </div>
              <div>
                <span className="clear-filters-span">{t('Dashboard::Clear filter(s)')}</span>
              </div>
            </div>
          )}
          <FilterButton
            onClick={() => setFiltersVisible(true)}
            isActive={isActive}
            className="mt"
          >
            {t('Dashboard::Filter')}
          </FilterButton>
        </FilterContainerStyle>
      </Divider>
      <section>
        <div className="main">
          <IncidentsTrend
            t={t}
            data={incidentsTrend}
            period={activeFilters.periods}
          />
          <MitigationActionsTrend
            t={t}
            data={mitigationActionsTrend}
            period={activeFilters.periods}
            organisationName={organisationName}
          />
          <EventsDistribution
            t={t}
            data={eventsDistribution}
            period={activeFilters.periods}
          />
        </div>
      </section>
      <ModalFilters
        t={t}
        initialFilters={initialFilters}
        setFiltersVisible={setFiltersVisible}
        setActiveFilters={setActiveFilters}
        clearFilters={clearFilters}
        setClearFilters={setClearFilters}
        filtersVisible={filtersVisible}
        onSubmit={(val) => onSubmit(val)}
      />
    </div>
  );
};

export default connect(((dashboard) => (dashboard)), actions)(RecordedEventsSection);
